import React from 'react'
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from "react-redux";


const PrivateRoute = ({ children, ...rest }) => {
    const {isLoggedIn } = useSelector(state => state.auth);







    return (
      <Route {...rest} render={() => {
        return isLoggedIn 
          ? children
          : <Redirect to='/login' />
      }} />
    )
  }

export default PrivateRoute